import { CheckmarkFilled, InProgress, CircleDash } from '@carbon/react/icons';
import { DocumentInterpretationResponse } from 'types/api-responses';

import style from './interpretation-review-count.module.scss';
import { getReviewDetails } from 'lib/review-interpretation';
import reviewStatusTypes from 'enums/review_status_types.json';
import { format0 } from 'utils/number';

const InterpretationReviewCount = ({
  reviewAttributes,
}: {
  reviewAttributes?: DocumentInterpretationResponse['reviewAttributes'];
}) => {
  if (!reviewAttributes) {
    return null;
  }

  const { sectionsCount, totalReviewed, reviewStatus } =
    getReviewDetails(reviewAttributes);

  return (
    <>
      {reviewStatus === reviewStatusTypes.reviewed && (
        <CheckmarkFilled className={style.success} />
      )}
      {reviewStatus === reviewStatusTypes.pending && (
        <CircleDash className={style.pending} />
      )}
      {reviewStatus === reviewStatusTypes.partial && (
        <InProgress className={style.partial} />
      )}
      <span className={style.reviewCount}>{`${format0(
        totalReviewed
      )} out of ${format0(sectionsCount)}`}</span>
    </>
  );
};

export { InterpretationReviewCount };
